import useSWR from 'swr';

import {
  commendaAiConversationsKey,
  listCommendaAiConversations,
} from '@commenda/api/commenda-ai/api';
import { PanelHistoryMenu } from '@commenda/ui/commenda-ai/PanelHistoryMenu';
import { useConfig } from 'context/useConfig';

/** The shared history menu, over this surface's list. Reads the same SWR entry the full-page
 * sidebar reads, so one cache serves both and a conversation started here shows up there. */
export const ChatPanelHistoryMenu = ({
  activeConversationId,
  onSelect,
}: {
  activeConversationId: string | null;
  onSelect: (conversationId: string) => void;
}) => {
  const { companyId, user, isLoading: isConfigLoading } = useConfig();

  const {
    data: conversations,
    error,
    isLoading,
  } = useSWR(
    commendaAiConversationsKey(companyId, !isConfigLoading),
    ([, workspaceId]) => listCommendaAiConversations(workspaceId)
  );

  return (
    <PanelHistoryMenu
      conversations={conversations ?? []}
      activeConversationId={activeConversationId}
      onSelect={onSelect}
      {...(user?.id ? { viewerId: user.id } : {})}
      isLoading={isLoading}
      hasError={Boolean(error)}
    />
  );
};
